module.exports = __webpack_public_path__ + "static/media/Checking.ab3b02c2.svg";